var map = {
	"./back.svg": "ccfe",
	"./circle-border.svg": "a354",
	"./donated-w.svg": "7823",
	"./donated.svg": "94e4",
	"./field-1.svg": "03ea",
	"./field-2.svg": "25f8",
	"./field-3.svg": "ba29",
	"./field-4.svg": "299d",
	"./field-5.svg": "3148",
	"./field-6.svg": "d132",
	"./field-7.svg": "f7eb",
	"./field-dark-1.svg": "0d51",
	"./field-dark-2.svg": "432b",
	"./field-dark-3.svg": "74df",
	"./field-dark-4.svg": "7a59",
	"./field-dark-5.svg": "6053",
	"./field-dark-6.svg": "d5dc",
	"./field-dark-7.svg": "6195",
	"./field-project-10.svg": "b264",
	"./field-project-8.svg": "2f25",
	"./field-project-9.svg": "bf6a",
	"./field-project-dark-10.svg": "fc6f",
	"./field-project-dark-8.svg": "a11f",
	"./field-project-dark-9.svg": "cdd1",
	"./form_logo1.svg": "c4db",
	"./form_logo2.svg": "1fec",
	"./form_logo3.svg": "df89",
	"./hamburger-close.svg": "d0f3",
	"./hamburger.svg": "eab1",
	"./icon-come-funziona-conferma.svg": "c203",
	"./icon-come-funziona-confronto.svg": "5c3f",
	"./icon-come-funziona-presentati.svg": "b26b",
	"./icon-come-funziona-raccontaci.svg": "8f78",
	"./icon-come-funziona-trova.svg": "8a46",
	"./icon-footer-social-fb.svg": "dcd4",
	"./icon-footer-social-in.svg": "9f3a",
	"./icon-play.svg": "52eb",
	"./icon-quote.svg": "6d05",
	"./logo-white.svg": "f295",
	"./logo.svg": "9b19",
	"./next.svg": "b2f3",
	"./next_blue.svg": "5d5b",
	"./pause-button.svg": "c974",
	"./paypal.svg": "dbab",
	"./play-button.svg": "0c7a",
	"./scuola1.svg": "7c6f",
	"./scuola1_white.svg": "7477",
	"./scuola2.svg": "16e6",
	"./scuola2_white.svg": "6440",
	"./scuola3.svg": "1cc0",
	"./scuola3_white.svg": "2b0d",
	"./sent.svg": "88ef",
	"./sent_small_white.svg": "719d",
	"./sent_white.svg": "ed9b",
	"./social-fb.svg": "b527",
	"./social-in.svg": "5721",
	"./social-ln.svg": "26bb",
	"./social-tw.svg": "5597",
	"./star_empty.svg": "3d52",
	"./star_full.svg": "6fce",
	"./tick.svg": "4ab9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";